export default __webpack_public_path__ + "assets/images/43106c2df7c36a2134907e8c3575ebb8.png";